/**
 * Create a DOM node from a raw SVG string (imported via ?raw from the heroicons package).
 * We use ?raw because Vite's default SVG import returns a URL (for <img src>),
 * but we need inline DOM nodes to style with Tailwind classes and currentColor.
 *
 * Usage:
 *   import playSvg from "heroicons/20/solid/play.svg?raw"
 *   container.appendChild(heroicon(playSvg, "w-3.5 h-3.5"))
 */
export function heroicon(svgString: string, className?: string): SVGElement {
  const tpl = document.createElement("template")
  tpl.innerHTML = svgString.trim()
  const svg = tpl.content.firstElementChild as SVGElement
  if (className) svg.setAttribute("class", className)
  return svg
}
